import { render, staticRenderFns } from "./BusinessRenovationPage.vue?vue&type=template&id=408adc80&scoped=true&"
import script from "./BusinessRenovationPage.vue?vue&type=script&lang=js&"
export * from "./BusinessRenovationPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRenovationPage.vue?vue&type=style&index=0&id=408adc80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408adc80",
  null
  
)

export default component.exports